import { downgradeInjectable } from '@angular/upgrade/static';
import { LegacyAssetService } from '@mode/shared/contract-common';
import * as angular from 'angular';

export const AssetsModule = angular
  .module('mode.assets', [])
  .service('AssetService', downgradeInjectable(LegacyAssetService)).name;
